import { CONDITION_KEYS } from "../utils/constants";

export const fbViewContent = ({
  _id,
  brand,
  model,
  year,
  condition,
  color,
  transmission,
  // category,
  fuel,
  drivetrain,
  price,
  currency,
}) => {
  window.fbq("track", "ViewContent", {
    //(window as any) is a bad solution , the correct would be to extend the type for window in a d.ts and add the def for the fbq function

    content_type: "vehicle", // REQUIRED: DO NOT change this, must be set to 'vehicle'
    content_ids: [_id], // REQUIRED: array of vehicle IDs
    postal_code: "40101", // RECOMMENDED
    country: "Costa Rica", // RECOMMENDED  don't use abbreviations
    make: brand, // RECOMMENDED
    model, // RECOMMENDED
    year, // RECOMMENDED
    state_of_vehicle:
      condition === CONDITION_KEYS.NEW ? CONDITION_KEYS.NEW : "used", // RECOMMENDED
    exterior_color: color.exterior, // RECOMMENDED
    transmission, // RECOMMENDED
    // body_style: category, // RECOMMENDED - PENDING TO MAP TO META types https://www.facebook.com/business/help/328529297741092
    fuel_type: fuel, // RECOMMENDED
    drivetrain: drivetrain.toLowerCase(), // RECOMMDENDED
    price, // RECOMMENDED, up to 2 decimals optional
    value: price,
    currency, // REQUIRED if price and preferred_price_range is used
    // preferred_price_range: '[10000,20000]' // Optional up to two decimals, min,max
  });
};
